import { isLebtServiceFeesEnabled } from 'businessTraveller/selectors/businessTravellerServiceFeesSelectors'
import { createSelector } from 'reselect'

export const getBusinessTravellerCheckoutServiceFeeTotal = createSelector(
  (state: App.State) => state.checkout.cart.cartId,
  (state: App.State) => state.businessTraveller.serviceFees,
  (state: App.State) => isLebtServiceFeesEnabled(state),
  (
    cartId,
    serviceFees,
    lebtServiceFeesEnabled,
  ): number => {
    if (!lebtServiceFeesEnabled) {
      return 0
    }

    return serviceFees[cartId]?.amount ?? 0
  },
)

export const getBusinessTravellerCheckoutServiceFeeTotals = createSelector(
  (state: App.State) => state.checkout.cart.cartId,
  (state: App.State) => state.businessTraveller.serviceFees,
  (state: App.State) => isLebtServiceFeesEnabled(state),
  (
    cartId,
    serviceFees,
    lebtServiceFeesEnabled,
  ): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    let price: number = 0

    if (lebtServiceFeesEnabled) {
      const serviceFee = serviceFees[cartId]
      if (serviceFee) {
        price += serviceFee.amount ?? 0
      }
    }

    return {
      hasRequiredData: true,
      data: {
        price,
        memberPrice: 0,
        taxesAndFees: 0,
        value: 0,
        memberValue: 0,
        surcharge: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)
